module.exports = __webpack_public_path__ + "static/media/ok.941fc307.svg";